import request from '@/axios'
// import request from '@/utils/request'

export function Login (query) {
  //
  return request({
    url: '/auth/unified-login',
    method: 'POST',
    data: query
  })
}

export function ForgotPassword (payload) {
  //
  return request({
    url: '/auth/unified_forget_password',
    method: 'POST',
    data: payload
  })
}

export function getSubdomainExists (subdomainName) {
  return request({
    url: `/check_subdomain/${subdomainName}`,
    method: 'GET'
  })
}

export function reset_password (payload) {
  //
  return request({
    url: '/users/reset_password_internal',
    method: 'POST',
    data: payload
  })
}
export function fetch_accessible_module_list (id) {
  return request({
    url: `/users/fetch_accessible_module_list/A/${id}`,
    method: 'GET'
  })
}
export function new_fetch_accessible_module_list (customer_id) {
  return request({
    url: `V1/role/fetch_accessible_module_list/${customer_id}`,
    method: 'GET'
  })
}

export function ResetForgetPassword (payload) {
  //
  return request({
    url: '/auth/unified_reset_password',
    method: 'POST',
    data: payload
  })
}

export function getUserDetailsByToken (payload) {
  //
  return request({
    url: 'get_user_details_by_token',
    method: 'POST',
    data: payload
  })
}

export function googleLogin (url) {
  return request({
    url,
    method: 'GET'
  })
}

export function changePasswordApi (payload) {
  return request({
    url: '/users/reset_password_internal',
    method: 'POST',
    data: payload
  })
}

export function fetchCustomerDataBySubdomainAPI (payload) {
  return request({
    url:'auth/get_customer_data_by_subdomain',
    method: 'POST',
    data: payload
  })
}

export function loginWithQRApi (payload) {
  return request({
    url: '/auth/unified_login_qr_code',
    method: 'POST',
    data:payload
  })
}

export function checkQrCode (payload) {
  return request({
    url: '/auth/ClientUser/check_qrcode',
    method: 'POST',
    data:payload
  })
}

export function EachClientEdit (client_user_id, customer_id, payload) {
  return request({
    url: `/ClientUser/V1/edit/${client_user_id}/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
// test cicd SBR-3051